var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.24,
    height: 31.241,
    viewBox: "0 0 31.24 31.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69470",
    "data-name": "Group 69470",
    transform: "translate(-260.555 -633.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44811",
    "data-name": "Path 44811",
    d: "M273.873,652.7v0l5.89-3.351L273.873,646Z",
    fill: "#92a7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44812",
    "data-name": "Path 44812",
    d: "M276.183,633.716h-.008a15.616,15.616,0,1,0,.008,0Zm10.79,21.1a2.789,2.789,0,0,1-1.993,1.972c-1.757.474-8.805.474-8.805.474s-7.047,0-8.8-.474a2.789,2.789,0,0,1-1.993-1.973,31.882,31.882,0,0,1,0-10.92,2.834,2.834,0,0,1,1.993-2.005c1.757-.474,8.8-.474,8.8-.474s7.047,0,8.805.474a2.834,2.834,0,0,1,1.993,2.005h0a31.882,31.882,0,0,1,0,10.92Z",
    fill: "#92a7ba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8f24f11ee24d98e3ab0f422d4bc2779a.svg";
export { ForwardRef as ReactComponent };